/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_Confirmdelete1Inputs */

const zh_sidebar_confirmdelete1 = /** @type {(inputs: Sidebar_Confirmdelete1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`确认删除`)
};

const en_sidebar_confirmdelete1 = /** @type {(inputs: Sidebar_Confirmdelete1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm Delete`)
};

const es_sidebar_confirmdelete1 = /** @type {(inputs: Sidebar_Confirmdelete1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmar eliminación`)
};

/**
* | output |
* | --- |
* | "Confirm Delete" |
*
* @param {Sidebar_Confirmdelete1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const sidebar_confirmdelete1 = /** @type {((inputs?: Sidebar_Confirmdelete1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_Confirmdelete1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_sidebar_confirmdelete1(inputs)
	if (locale === "en") return en_sidebar_confirmdelete1(inputs)
	return es_sidebar_confirmdelete1(inputs)
});
export { sidebar_confirmdelete1 as "sidebar_confirmDelete" }